import React, { Component } from 'react';
import { connect } from 'react-redux'
import { FormGroup, Input, Col, Label } from 'reactstrap';
import { toast } from 'react-toastify';
import PaypalExpressBtn from 'react-paypal-express-checkout';
import SimpleReactValidator from 'simple-react-validator';
import { getMerchants, postPayment, getStripeToken, toOauth } from '../../api';
import LoadingOverlay from 'react-loading-overlay';

import Breadcrumb from "../common/breadcrumb";
import { removeFromWishlist } from '../../actions'
import { getCartTotal } from "../../services";
import { relative } from 'path';
import { portal, store } from '../../config';

class checkOut extends Component {

    constructor(props) {
        super(props)

        this.state = {
            payment: 'one-time',
            first_name: '',
            last_name: '',
            phone: '',
            email: '',
            cardNumber: '',
            cardType: '',
            cardClass: 'fa-credit-card',
            cardCvv: '',
            cardExp: '',
            country: '',
            address: '',
            city: '',
            state: '',
            pincode: '',
            promo_codSimpleReactValidatore: '',
            discount: 0,
            loading: false,
            create_account: ''
        }
        this.validator = new SimpleReactValidator();
    }

    setCardType() {
        const cardNumber = this.state.cardNumber.replace(/[ ]/g, '');
        let cardClass = 'fa-credit-card';
        let cardType = 'VISA';

        const cardRegex = {
            visa: /^4[0-9]/,
            masterCard: /^5[1-5]/,
            amex: /^3[47]/,
            discover: /^6(?:011|5[0-9]{2})/,
            dinersClub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
            JCB: /^(?:2131|1800|35\d{3})\d{11}$/,
        };

        if (cardRegex.visa.test(cardNumber)) {
            cardClass = 'fa-cc-visa';
            cardType = 'VISA';
        } else if (cardRegex.masterCard.test(cardNumber)) {
            cardClass = 'fa-cc-mastercard';
            cardType = 'MASTERCARD';
        } else if (cardRegex.amex.test(cardNumber)) {
            cardClass = 'fa-cc-amex';
            cardType = 'AMERICAN EXPRESS';
        } else if (cardRegex.discover.test(cardNumber)) {
            cardClass = 'fa-cc-discover';
            cardType = 'DISCOVER';
        }

        this.setState({
            cardType,
            cardClass,
        });
    }

    formatCardNumber = (data) => {
        let cardNumber;
        if (/^3[47]/.test(data)) {
            const tempVal = data.replace(/\s/g, '');
            cardNumber = (tempVal.slice(0, 4).replace(/(.{4})/g, '$1 ')
                + tempVal.slice(4, 10).replace(/(.{6})/g, '$1 ')
                + tempVal.slice(10, 15)).trim();
        } else {
            const value = data.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
            const matches = value.match(/\d{4,16}/g);
            const match = (matches && matches[0]) || '';
            const parts = [];
            for (let i = 0, len = match.length; i < len; i += 4) {
                parts.push(match.substring(i, i + 4));
            }
            if (parts.length) {
                cardNumber = parts.join(' ');
            } else {
                cardNumber = data;
            }
        }
        return cardNumber;
    }

    setStateFromInput = (event) => {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);

    }

    setStateFromCheckbox = (event) => {
        var obj = {};
        obj[event.target.name] = event.target.checked;
        this.setState(obj);

        if (!this.validator.fieldValid(event.target.name)) {
            this.validator.showMessages();
        }
    }

    checkhandle(value) {
        this.setState({
            payment: value
        })
    }

    SignInClick = async () => {
        await toOauth();
    }

    ApplyClick = async () => {
        const { cartItems, promocodes, total } = this.props;
        const { promo_code } = this.state;
        const matchedCode = promocodes
            .find(({ code }) => promo_code === code);
        if (matchedCode) {
            let applies = true;
            // #1 valid by date
            const today = new Date();
            const startDate = new Date(matchedCode.start_date);
            const endDate = new Date(matchedCode.end_date);
            if (startDate > today || today > endDate) {
                applies = false;
                toast.error("Promotional code is invalid or expired!");
                return;
            }
            // #2 minimum order
            const totalItems = cartItems
                .reduce((total,{ qty }) => total + qty, 0);
            if (applies && matchedCode.minimum_order
                && totalItems < matchedCode.minimum_order
            ) {
                applies = false;
                toast.error(`Need mininum ${matchedCode.minimum_order} items to avail this promotional code.`);
            }
            // #3 minimum purchase
            if (applies && matchedCode.minimum_purchase
                && total * 100 < matchedCode.minimum_purchase 
            ) {
                applies = false;
                toast.error(`Need mininum $${(matchedCode.minimum_purchase / 100.0).toFixed(2)} items to avail this promotional code.`);
            } 
            const items = [];
            if (applies && matchedCode.products.length > 0) {
                console.log('Applies to only certain products');
                matchedCode.products.forEach(p => {
                    console.log(p);
                    cartItems
                    .forEach(item => {
                        if(item.id === p.id && item.qty > 0) {
                            console.log(`match ${item.id} and ${p.id}`);
                            items.push(item);
                        } 
                        console.log(`no match ${item.id} and ${p.id}`);
                    });

                });
                console.log('items', items);   
                if (items.length <= 0) {
                    applies = false;
                    toast.error(`Promotional code does not apply to any products in cart.`);
                }
            }

            if (applies) {     
                console.log('items', items);    
                toast.success(`Promotional code ${promo_code} applied!`);
                if (matchedCode.type === 'MONETARY') {
                    this.setState({
                        discount: (matchedCode.value / 100.0).toFixed(2),
                    });
                } else {
                    let discount = 0;
                    if (matchedCode.products.length > 0) {
                        items.forEach(item => {
                            discount += item.sum * matchedCode.value / 100.0;
                        });
                    } else {
                        discount = (total * matchedCode.value / 100.0);
                    }
                    this.setState({
                        discount: discount.toFixed(2),
                    });
                }
            }
        } else {
            toast.error(`Invalid promotional code.`);
        }
    }

    PayPortalClick = async () => {
        if (this.validator.allValid()) {
            try {
                this.setState({
                    loading: true,
                });
                const {
                    first_name,
                    last_name,
                    email,
                    cardNumber,
                    cardType,
                    cardClass,
                    cardCvv,
                    cardExp,
                    promo_code,
                    discount,
                } = this.state; 

                const { cartItems, symbol, total } = this.props;

                const products = cartItems
                    .filter(item => item.qty > 0)
                    .map(item => ({
                        product_name: item.name,
                        product_quantity: item.qty,
                        currency: symbol,
                        price: item.sum * 100,
                    }))

                let paidProducts = []
                cartItems
                    .filter(item => item.qty > 0)
                    .forEach(item => {
                        item.source.units_sold = item.qty;
                        paidProducts
                            .push(item.source);
                    })
                const { data } = await getMerchants();
                const tokenUrl = data.gateway.token_url;
                const publicKey = data.public_key;

                let [expMonth, expYear] = cardExp.split('/');
                if (expYear.length === 2) {
                    expYear = `20${expYear}`;
                }
                expMonth = parseInt(expMonth, 10);
                expYear = parseInt(expYear, 10);
                const card = {
                    name: `${first_name} ${last_name}`,
                    cardNumber,
                    cardType,
                    cardCvv,
                    expMonth,
                    expYear
                };
                let response = await getStripeToken(publicKey, tokenUrl, card);
                const payload = {
                    portal,
                    store,
                    token: response.data.id,
                    email,
                    name: `${first_name} ${last_name}`,
                    amount: parseInt((total - discount).toFixed(2) * 100,10),
                    subtotal: parseInt(total * 100, 10),
                    discount: parseInt(discount * 100, 10),
                    currency: 'USD',
                    description: `${portal.name}`,
                    products,
                    paidProducts,
                    ownerEmail: `${portal.ownerEmail}`,
                    promo_code: promo_code,
                    invoice_note: store.note,
                    test: data.is_test,
                };

                response = await postPayment(payload);
                this.setState({
                    loading: false,
                });
                this.props.history.push({
                    pathname: '/ordersuccess',
                    state: { payment: response.data, email, items: this.props.cartItems, subTotal: total, discount, orderTotal: (total - discount).toFixed(2), symbol: this.props.symbol }
                })
            } catch (err) {
                console.log('got error', err)
                toast.error("Payment declined! Please try again, or email support@payportal.org");
                this.setState({
                    loading: false,
                });
            }
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.forceUpdate();
        }
    }

    render() {
        const { cartItems, symbol, total } = this.props;

        // Paypal Integration
        const onSuccess = (payment) => {
            this.props.history.push({
                pathname: '/order-success',
                state: { payment: payment, items: cartItems, orderTotal: total, symbol: symbol }
            })

        }

        const onCancel = (data) => {
            console.log('The payment was cancelled!', data);
        }

        const onError = (err) => {
            console.log("Error!", err);
        }

        const client = {
            sandbox: 'AZ4S98zFa01vym7NVeo_qthZyOnBhtNvQDsjhaZSMH-2_Y9IAJFbSD3HPueErYqN8Sa8WYRbjP7wWtd_',
            production: 'AZ4S98zFa01vym7NVeo_qthZyOnBhtNvQDsjhaZSMH-2_Y9IAJFbSD3HPueErYqN8Sa8WYRbjP7wWtd_',
        }


        return (
            // eslint-disable-next-line no-unused-expressions
            <LoadingOverlay
                active={this.state.loading}
                spinner
                text={`Processing payment...`}
            >
                <div>
                    <Breadcrumb title={'Checkout'} prev={'Store'} url={'/'} />

                    <section className="section-b-space">
                        <div className="container padding-cls">
                            <div className="checkout-page">
                                <div className="checkout-form">
                                    <form>
                                        <div className="checkout row">
                                            <div className="col-lg-6 col-sm-12 col-xs-12">
                                                <div className="checkout-title">
                                                    <h3>Billing Details</h3>
                                                </div>
                                                <div className="row check-out">
                                                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                                        <div className="field-label">First Name</div>
                                                        <input type="text" name="first_name" placeholder="First Name" value={this.state.first_name} onChange={this.setStateFromInput} />
                                                        {this.validator.message('first_name', this.state.first_name, 'required|alpha')}
                                                    </div>
                                                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                                        <div className="field-label">Last Name</div>
                                                        <input type="text" name="last_name" placeholder="Last Name" value={this.state.last_name} onChange={this.setStateFromInput} />
                                                        {this.validator.message('last_name', this.state.last_name, 'required|alpha')}
                                                    </div>
                                                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                                        <div className="field-label">Phone</div>
                                                        <input type="text" name="phone" placeholder="Phone" value={this.state.phone} onChange={this.setStateFromInput} />
                                                        {this.validator.message('phone', this.state.phone, 'required|phone')}
                                                    </div>
                                                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                                        <div className="field-label">Email Address</div>
                                                        <input type="text" name="email" placeholder="Email" value={this.state.email} onChange={this.setStateFromInput} />
                                                        {this.validator.message('email', this.state.email, 'required|email')}
                                                    </div>
                                                    <div className="form-group col-md-12 col-sm-12 col-xs-12">
                                                        <div className="field-label">Number</div>
                                                        <input type="text" placeholder="Card number" name="number" value={this.state.cardNumber}
                                                            onChange={(event) => {
                                                                this.setState({
                                                                    // card: {
                                                                    //     number: this.formatCardNumber(event.target.value),
                                                                    // },
                                                                    cardNumber: this.formatCardNumber(event.target.value),
                                                                }, () => {
                                                                    this.setCardType();
                                                                });
                                                            }}
                                                        />
                                                        {this.validator.message('number', this.state.cardNumber, 'required|card_num')}
                                                        <em className={`fa payment-card ${this.state.cardClass}`} />
                                                    </div>
                                                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                                        <div className="field-label">Expiry</div>
                                                        <input type="text" placeholder="MM/YYYY" name="cardExp" value={this.state.cardExp} onChange={this.setStateFromInput} />
                                                        {this.validator.message('expiry', this.state.cardExp, 'required|card_exp')}
                                                    </div>
                                                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                                        <div className="field-label">CVC</div>
                                                        <input type="password" placeholder="CVC" name="cardCvv" value={this.state.cardCvv} onChange={this.setStateFromInput} />
                                                        {this.validator.message('cvv', this.state.cardCvv, 'required|min:3|max:4')}
                                                    </div>
                                                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                                        <img width="300px" src="https://storage.googleapis.com/payportal-static/payportal-card-logos.png" alt="" />                                                </div>
                                                    <br />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-sm-12 col-xs-12">
                                                <div className="checkout-details">
                                                    <div className="order-box">
                                                        <div className="title-box">
                                                            <div>Product <span> Total</span></div>
                                                        </div>
                                                        <ul className="qty">
                                                            {cartItems.map((item, index) => {
                                                                if (item.sum > 0)
                                                                    return <li key={index}>{item.name} × {item.qty} <span>{symbol} {item.sum.toFixed(2)}</span></li>
                                                            })
                                                            }
                                                        </ul>
                                                        <ul className="sub-total">
                                                            <li>Subtotal <span className="count">{symbol}{parseFloat(total,10).toFixed(2)}</span></li>
                                                        </ul>
                                                        {
                                                            this.state.discount 
                                                                ?  (
                                                                    <ul className="sub-total">
                                                                        <li>Discount <span className="count text-success">{symbol}{this.state.discount}</span></li>
                                                                        <li><h6>Code: {this.state.promo_code}</h6></li>
                                                                    </ul>
                                                                )
                                                                : null
                                                        }
                                                        <ul className="total">
                                                            <li>Total <span className="count">{symbol}{(total - this.state.discount).toFixed(2)}</span></li>
                                                        </ul>
                                                    </div>

                                                    <div className="payment-box">
                                                        <div className="upper-box">
                                                            <div className="payment-options">
                                                                <ul>
                                                                    {/* <li>
                                                                    <div className="radio-option stripe">
                                                                        <input type="radio" name="payment-group" id="payment-2" defaultChecked={true} onClick={() => this.checkhandle('stripe')} />
                                                                        <img width="100" height="25" src={'https://storage.googleapis.com/payportal-email/logo2.png'} alt=""/>
                                                                    </div>
                                                                </li> */}
                                                                    {/* <li>
                                                                    <div className="radio-option paypal">
                                                                        <input type="radio" name="payment-group" id="payment-1" onClick={() => this.checkhandle('paypal')} />
                                                                            <label htmlFor="payment-1">PayPal<span className="image"><img src={`${process.env.PUBLIC_URL}/assets/images/paypal.png`} alt=""/></span></label>
                                                                    </div>
                                                                </li> */}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        {(total !== 0) ?
                                                            <div>
                                                                <div className="text-left">
                                                                    <p className="mb-2">Apply Promotional Code</p>
                                                                </div>
                                                                <div className="text-left d-inline-flex mb-2 justify-content-between w-100">
                                                                    <input className="mr-2 flex-grow-1" type="text" name="promo_code" placeholder="" value={this.state.promo_code} onChange={this.setStateFromInput} />
                                                                    <button style={{ height: '45px' }} className="btn-solid btn black-btn" onClick={(event) => { event.preventDefault(); this.ApplyClick() }}>Apply</button>
                                                                </div>
                                                                <div className="text-right mt-5" style={{ position: 'relative' }}>
                                                                    <div style={{ position: 'absolute', bottom: 0, left: 0 }}>
                                                                        <p><a target="_blank" href="https://policies.payportal.org">Terms and conditions</a></p>
                                                                    </div>
                                                                    {(this.state.payment === 'subscription') ? <button type="button" className="btn-solid btn" onClick={() => this.PayPortalClick()} >Sign In</button> :
                                                                        <button type="button" className="btn-solid btn" onClick={() => this.PayPortalClick()} >Pay Now</button>}
                                                                </div>
                                                                <div className="text-right mt-4">
                                                                    <p> <em className="fa fa-lock" /> Secured by <a href="https://www.payportal.org" target="_blank" ><img width="60" height="12.5" src="https://storage.googleapis.com/payportal-random-static/payportal3.png" alt="" /></a></p>
                                                                </div>
                                                            </div>
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="row section-t-space">
                                        <div className="col-lg-6">
                                            <div className="stripe-section">
                                                <h5>stripe js example</h5>
                                                <div>
                                                    <h5 className="checkout_class">dummy test</h5>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td>cart number</td>
                                                                <td>4242424242424242</td>
                                                            </tr>
                                                            <tr>
                                                                <td>mm/yy</td>
                                                                <td>2/2020</td>
                                                            </tr>
                                                            <tr>
                                                                <td>cvc</td>
                                                                <td>2222</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 m-sm-t-2">
                                            <div className="stripe-section">
                                                <h5>paypal example</h5>
                                                <div>
                                                    <h5 className="checkout_class">dummy test</h5>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td>cart number</td>
                                                                <td>4152521541244</td>
                                                            </tr>
                                                            <tr>
                                                                <td>mm/yy</td>
                                                                <td>11/18</td>
                                                            </tr>
                                                            <tr>
                                                                <td>cvc</td>
                                                                <td>521</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </LoadingOverlay>
        )
    }
}
const mapStateToProps = (state) => ({
    cartItems: state.cartList.cart,
    symbol: state.data.symbol,
    total: getCartTotal(state.cartList.cart),
    promocodes: state.cartList.promocodes,
})

export default connect(
    mapStateToProps,
    { removeFromWishlist }
)(checkOut)